import { PiArrowElbowUpLeftBold } from "react-icons/pi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdContentCopy } from "react-icons/md";

const ReplyInput = ({ deleteHandler = () => {}, replyHandler = () => {}, type = "reciever", Css, copyHandler = () => {} }) => {
  return (
    <div>
      <div className={`flex flex-col justify-between cursor-pointer mt-5 bg-white relative z-30 left-7 w-[250px] ${Css}`}>
        <div className="flex text-sm font-normal items-center gap-x-2 border-b border-[#F0F0F0] py-3 px-3 " onClick={replyHandler}>
          {/* <img src="/icons/reply_icon.png" style={{ width: "24px", height: "24px" }} /> */}
          <PiArrowElbowUpLeftBold size={19} />
          <p>Reply</p>
        </div>
        <div className="flex text-sm font-normal items-center gap-x-2 border-b border-[#F0F0F0] py-3 px-3 " onClick={copyHandler}>
          <MdContentCopy size={19} />
          <p>Copy</p>
        </div>

        {type != "reciever" ? (
          <div className="flex text-sm font-normal items-center gap-x-2 border-b border-[#F0F0F0] py-3 px-3" onClick={deleteHandler}>
            <RiDeleteBin6Line size={19} />
            {/* <img src="/icons/delete_icon.png" style={{ width: "24px", height: "24px" }} /> */}
            <p>Delete</p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ReplyInput;
